<template>
  <div>
    <b-card>
    <b-row>
      <b-col md="6">
        <apexchart
            ref="chart1"
            type="pie"
            :options="options1"
            :series="series1"
            style="margin-left: 100px"></apexchart>
      </b-col>
      <b-col md="6">
        <apexchart
            ref="chart2"
            type="pie"
            :options="options2"
            :series="series2"
            style="margin-left: 60px"></apexchart>
      </b-col>
    </b-row>
    </b-card>
  </div>
</template>

<script>


export default {
  name: "StatsChart",
  props: {
    applications: {
      required:true,
    },
    accepted: {
      required: true,
    },
    rejected: {
      required:true,
    },
  },
  data() {
    return {
      options1: {
        chart: {
          type: 'pie',
        },
        labels: [
            this.$t('message.Hired'),
            this.$t('message.Bosh_ish')
        ]
      },
      options2: {
        chart: {
          type: 'pie',
        },
        labels: [
            this.$t('message.Accepted_applications'),
          this.$t('message.Rejected_applications'),
        ]
      },
      series1: [0,0],
      series2: [0,0],
    }
  },

  watch:{
    applications:{
      immediate: true,
      handler() {
        this.series1 = [this.accepted,this.applications]
        this.series2 = [this.accepted, this.rejected];
        // eslint-disable-next-line no-console
        console.log(this.accepted,this.rejected, this.applications)
      }
    }
  }

}
</script>

<style scoped>

</style>
